module.exports = __webpack_public_path__ + "img/aboutbg.054cc8b.054cc8bb.jpg";